import { Metrics } from '@moonpig/web-core-monitoring'
import { ServerResponse } from 'http'

export type ServerRedirectResponse = {
  source: string
  destination: string
  permanent: boolean
}

export type ServerRedirect = (
  asPath: string,
) => Promise<null | ServerRedirectResponse>

export const handleServerRedirects = async (
  customAsPath: string,
  res: ServerResponse | undefined,
  metrics: Metrics,
  redirect?: ServerRedirect,
) => {
  if (customAsPath && res && redirect) {
    const redirectResponse = await redirect(customAsPath)
    if (redirectResponse) {
      const source = redirectResponse.source
      const destination = redirectResponse.destination
      const permanent = redirectResponse.permanent
      const statusCode = permanent ? 301 : 302
      res.statusCode = statusCode
      res.setHeader('Location', destination)
      if (permanent) {
        res.setHeader('Cache-Control', 'public, max-age=2628000')
      }
      metrics.count({
        metricName: 'redirect',
        metricCount: 1,
        metricDimensions: {
          source: source.substring(0, 255),
          permanent: permanent ? 'true' : 'false',
        },
      })
      res.end()

      return {
        pageProps: {
          statusCode,
          location: destination,
        },
      } as const
    }
  }
  return null
}
